const initialState = {
  selectedColor:'',
  razzer:[],
  orderDetail:[],
  deliverdatetime:{},
  deliverslot:[],
  myorders:undefined,
  verification_status:undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'setVerification_status':
      return {
        ...state,
        verification_status: action.payload
      };
    case 'setSelectedColor':
      return {
        ...state,
        selectedColor: action.payload
      };
      case 'setMyorder':
      return {
        ...state,
        myorders: action.payload
      };
    case 'setRazzer':
      return {
        ...state,
        razzer: action.payload
      };
    case 'setdeliverdatetime':
      return {
        ...state,
        deliverdatetime: action.payload
      };
    case 'setdeliverslot':
      return {
        ...state,
        deliverslot: action.payload
      };
    case 'setorderDetail':
      return {
        ...state,
        orderDetail: action.payload
      };
    default:
      return state;
  }
};
